import { AnimatePresence, motion } from "framer-motion";
import { array, string } from "prop-types";
import React from "react";

import UpsellCarousel from "./UpsellCarousel";
import Typography from "@components/shared/Typography";

import { useIsOnFirstBasketStep } from "@hooks/useIsOnFirstBasketStep";

const UpsellContainer = ({ options, title }) => {
  const isReadOnly = !useIsOnFirstBasketStep();

  return (
    <AnimatePresence initial={false}>
      {options?.length && (
        <motion.div
          animate="open"
          className="border-t border-t-primaryOrange py-4 flex-col gap-2"
          exit="collapsed"
          initial="collapsed"
          variants={{
            open: {
              opacity: 1,
              height: "auto",
              display: "flex",
            },
            collapsed: {
              opacity: 0,
              height: 0,
              transitionEnd: { display: "none" },
              transition: { duration: 0.3, type: "tween" },
            },
          }}
        >
          <Typography className="text-lg font-semibold uppercase">
            {title}
          </Typography>
          <UpsellCarousel isReadOnly={isReadOnly} options={options} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

UpsellContainer.propTypes = {
  options: array,
  title: string,
};

export default UpsellContainer;
